import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconColdEmail = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <path
          d="M4.45703 8.33333V4.36243C4.45703 4.16226 4.70818 3.99999 5.01798 4L14.0173 4.00028C14.327 4.00028 14.5782 4.16255 14.5782 4.36271V8.33333"
          stroke="#2F393E"
          strokeWidth="0.888889"
        />
        <path
          d="M10.332 14.787H3.89366C3.58351 14.787 3.33209 14.5275 3.33209 14.2074L3.33203 8.62055C3.33202 8.17195 3.8046 7.8934 4.17897 8.12129L9.26402 11.2171C9.44092 11.3248 9.66062 11.3243 9.83708 11.2157L14.853 8.12882C15.2273 7.8985 15.7022 8.17681 15.7022 8.62657V10.6663"
          stroke="#2F393E"
          strokeWidth="0.888889"
        />
        <rect
          x="5.58203"
          y="5.3335"
          width="7.87201"
          height="0.706874"
          rx="0.353437"
          fill="#2F393E"
        />
        <rect
          x="5.58203"
          y="7.02197"
          width="3.93601"
          height="0.706874"
          rx="0.353437"
          fill="#2F393E"
        />
        <circle
          cx="13.9987"
          cy="13.9997"
          r="2.66667"
          stroke="#FF9D28"
          strokeWidth="0.622222"
        />
        <path
          d="M12.9336 14.1597L13.5736 14.7997L15.1736 13.1997"
          stroke="#FF9D28"
          strokeWidth="0.622222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
